import { FormElementSocialMediaType } from './form-element-social-media-type.model';
import { FormElement } from '../form-element.model';

export class FormElementSocialMedia extends FormElement {
  SocialMediaFields: FormElementSocialMediaType[];
  public constructor() {
    super();
    this.SocialMediaFields = [];
  }
}
